import { AxiosStatic, AxiosError } from "axios";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { FastTrackPitPupMedicalFormQuestionnaire, FastTrackPitPupMedicalFormAutoSaveDto } from "./models";

export class FastTrackPitPupMedicalFormApi {
    private readonly apiUrl = "/api/fastTrackPitPupMedicalForm";

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async get(): Promise<FastTrackPitPupMedicalFormQuestionnaire> {
        const response = await this.axios.get(`${this.apiUrl}`);
        return response.data;
    }

    public async getByTaskId(ohCaseId: string): Promise<FastTrackPitPupMedicalFormQuestionnaire> {
        const response = await this.axios.get(`${this.apiUrl}/OhCase/${ohCaseId}`);
        return response.data;
    }

    public async save(questions: AnsweredQuestionWithId[], eTag: string) {
        try {
            const response = await this.axios.post<FastTrackPitPupMedicalFormAutoSaveDto>(
                `${this.apiUrl}/save`, {
                    data: { questions },
                    eTag
                });
            return response.data;
        } catch (ex) {
            const axiosError = ex as AxiosError;
            if (axiosError.response?.status === 400) {
                const error = { message: "Could not save as a newer version exists", status: 400 };
                throw error;
            } else {
                throw ex;
            }
        }
    }

    public async submit(questions: AnsweredQuestionWithId[], customerId: string) {
        const response = await this.axios.post<FastTrackPitPupMedicalFormAutoSaveDto>(
            `${this.apiUrl}/customer/${customerId}/submit`, {
                data: { questions }
            });
        return response.data;
    }
}
